import { EventEmitter } from 'events';
import { useCallback, useEffect } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';

export const eventEmitter = new EventEmitter();

export const useSagaNavigator = () => {
  const navigate = useNavigate();

  const goToRoute = useCallback(
    ({ path, options }: { path: To; options: NavigateOptions }) => {
      navigate(path, options);
    },
    [navigate],
  );

  useEffect(() => {
    eventEmitter.addListener('navigate', goToRoute);
    return () => {
      eventEmitter.removeListener('navigate', goToRoute);
    };
  }, [goToRoute]);

  return;
};
